import { createMongoAbility } from "@casl/ability";
import { ROLE_ABILITY } from "@src/utility/ability/common";
// import secureLocalStorage  from  "react-secure-storage";

// Read ability from secureLocalStorage
const abilityJSON = localStorage.getItem("ability");
const storedAbility = abilityJSON ? JSON.parse(abilityJSON) : [];

const userInfoJSON = localStorage.getItem("userInfo");
const userInfo = userInfoJSON ? JSON.parse(userInfoJSON) : {};
const role = userInfo?.user?.role;
const roleAbility = ROLE_ABILITY[role] || [];

// Always merge this role's ability so new permissions are available without re-login
const seen = new Set(storedAbility.map((r) => `${r.action}:${r.subject}`));
const merged = [...storedAbility];
roleAbility.forEach((r) => {
  const key = `${r.action}:${r.subject}`;
  if (!seen.has(key)) merged.push(r);
});

const mergedAbility = createMongoAbility(merged);

export default mergedAbility;
